const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const downloadFile = async (endpoint: string, filename: string) => {
  const token = localStorage.getItem('auth_token');
  const response = await fetch(`${API_URL}/api/v1/export/${endpoint}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Accept': 'application/octet-stream',
    },
  });

  if (!response.ok) throw new Error('Erro ao exportar');

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const exportService = {
  geralPdf: (periodo = 'mes') => downloadFile(`geral/pdf?periodo=${periodo}`, `relatorio-geral-${periodo}.pdf`),
  veiculosPdf: () => downloadFile('veiculos/pdf', 'relatorio-veiculos.pdf'),
  veiculosExcel: () => downloadFile('veiculos/excel', 'veiculos.xlsx'),
  motoristasPdf: () => downloadFile('motoristas/pdf', 'relatorio-motoristas.pdf'),
  motoristasExcel: () => downloadFile('motoristas/excel', 'motoristas.xlsx'),
  abastecimentosPdf: () => downloadFile('abastecimentos/pdf', 'relatorio-abastecimentos.pdf'),
  abastecimentosExcel: () => downloadFile('abastecimentos/excel', 'abastecimentos.xlsx'),
  manutencoesPdf: () => downloadFile('manutencoes/pdf', 'relatorio-manutencoes.pdf'),
  manutencoesExcel: () => downloadFile('manutencoes/excel', 'manutencoes.xlsx'),
  despesasPdf: () => downloadFile('despesas/pdf', 'relatorio-despesas.pdf'),
  despesasExcel: () => downloadFile('despesas/excel', 'despesas.xlsx'),
  viagensPdf: () => downloadFile('viagens/pdf', 'relatorio-viagens.pdf'),
  viagensExcel: () => downloadFile('viagens/excel', 'viagens.xlsx'),
};
